import { vleTokenFetcher } from '@api/fetcher/ambassdor'
import { useMutation } from '@tanstack/react-query'

type Props = {
    data: any
    isLoading: boolean
    mutate: any
    error: any
}

const useVleToken = (): Props => {
    const { data, isLoading, mutate, error } = useMutation(
        ['vle-token'],
        vleTokenFetcher
    )

    return {
        data: data?.data,
        isLoading,
        mutate,
        error,
    }
}

export default useVleToken